const experiences = [
  {
    title: 'Front End Developer',
    company: 'Rens Original',
    time: 'January 2019 - Present',

    website: 'https://www.rensoriginal.com',
    tech: [
      'Shopify',
      'React',
      'Node',
      'GraphQL',
      'PostgreSQL',
      'Scss',
      'Google Cloud',
      'Google Analytics',
      'A/B Test'
    ]
  },
  {
    title: 'Front End Developer',
    company: 'Digia',
    time: 'October 2018 - December 2019',

    website: 'https://www.digia.com/en/',
    tech: ['React', 'Redux']
  },
  {
    title: 'Front End Developer',
    company: 'Integrify',
    time: 'January 2018 - September 2018',

    website: 'https://www.integrify.io/en/',
    tech: ['HTMl', 'CSS', 'Scss', 'Javascript', 'React', 'Redux', 'Node', 'MongoDB', 'GraphQL']
  }
]

export default experiences
